<app-breadcrumb *ngIf="showFilter && !onlyLicenses" master="Administracja" [parentName]="'Użytkownicy'" [name]="'Lista'"></app-breadcrumb>
<app-breadcrumb *ngIf="onlyLicenses" master="Administracja" [parentName]="'Licencje'" [name]="'Użytkownicy'"></app-breadcrumb>
<div class="user-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="user-list-filters" *ngIf="showFilter">
    <mat-form-field class="user-list-filter" *ngIf="!limitedView">
      <mat-label>Nazwa</mat-label>
      <input matInput placeholder="JanKow123" name="contains$username" [(ngModel)]="initialFilters.contains$username">
    </mat-form-field>

    <mat-form-field class="user-list-filter">
      <mat-label>Imię</mat-label>
      <input matInput placeholder="Jan" name="contains$firstName" [(ngModel)]="initialFilters.contains$firstName">
    </mat-form-field>

    <mat-form-field class="user-list-filter">
      <mat-label>Nazwisko</mat-label>
      <input matInput placeholder="Kowalski" name="contains$lastName" [(ngModel)]="initialFilters.contains$lastName">
    </mat-form-field>

    <mat-form-field class="user-list-filter">
      <mat-label>Numer telefonu</mat-label>
      <input matInput placeholder="+48500200300" name="contains$phone" [(ngModel)]="initialFilters.contains$phone">
    </mat-form-field>

    <mat-form-field class="user-list-filter">
      <mat-label>Email</mat-label>
      <input matInput placeholder="adres@test.pl" name="contains$email" [(ngModel)]="initialFilters.contains$email">
    </mat-form-field>

    <app-dict-departments
      *ngIf="!limitedView"
      label="Dział"
      class="user-list-filter" [multiple]="false"
      [(ngModel)]="initialFilters.department" name="department"
    ></app-dict-departments>

    <app-dict-users
      *ngIf="!limitedView"
      class="user-list-filter" label="Przełożony"
      [multiple]="false"
      [(ngModel)]="initialFilters.supervisor" name="supervisor"
    ></app-dict-users>

    <mat-form-field
      appearance="standard"
      class="user-list-filter"
      *ngIf="!limitedView">
      <mat-label>Aktywny</mat-label>
      <mat-select [(ngModel)]="initialFilters.active" name="active">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field
      appearance="standard"
      class="user-list-filter"
      *ngIf="!limitedView">
      <mat-label>Widoczny na liście kontaktów</mat-label>
      <mat-select [(ngModel)]="initialFilters.employeeList360" name="employeeList360">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field
      appearance="standard"
      class="user-list-filter"
      *ngIf="!limitedView">
      <mat-label>Typ użytkownika</mat-label>
      <mat-select [(ngModel)]="initialFilters.role" name="role">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="'ROLE_ASF360'">ASF360</mat-option>
        <mat-option [value]="'ROLE_ADMIN'">Admin</mat-option>
        <mat-option [value]="'ROLE_USER'">Pracownik</mat-option>
      </mat-select>
    </mat-form-field>
  </form>

  <div class="user-list-buttons" *ngIf="showFilter">
    <button   *ngIf="!limitedView && (userPermissions | async).user.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).user.read_report"
            mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button   *ngIf="limitedView && (userPermissions | async).employees.read_report && !onlyLicenses" (click)="downloadReport()" [disabled]="!(userPermissions | async).employees.read_report"
            mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <div class="user-add-buttons" *ngIf="null !== this.permissionTagId">

    <button
      [disabled]="!(userPermissions | async).asf_360.admin_root"
      (click)="add()"
      mat-raised-button
    ><mat-icon>add</mat-icon> <span> Dodaj użytkownika</span></button>

    <button
      [disabled]="!(userPermissions | async).asf_360.admin_root"
      (click)="import()"
      mat-raised-button
    ><mat-icon>upload_file</mat-icon> <span> Importuj użytkowników</span></button>
  </div>

  <table mat-table [dataSource]="users">

    <ng-container matColumnDef="licenseFullName">
      <th mat-header-cell *matHeaderCellDef > Imię i nazwisko </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/licencje/uzytkownicy/szczegoly', element.uuid]">
          {{element.firstName}} {{element.lastName}}
        </a>
      </td>
    </ng-container>

    <!-- Position Column -->
    <ng-container matColumnDef="username">
      <th mat-header-cell *matHeaderCellDef> Login </th>
      <td mat-cell *matCellDef="let element">
        <div class="circular-image">
          <img class="circular-image small-avatar user-list-avatar"
               [src]="element.avatar ? '/rest/sso/api/user/' + element.uuid + '/avatar'
               : '/assets/avatar.png'"
               alt="Zdjęcie"/>
        </div>
        <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.uuid]">{{element.username}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="typ">
      <th mat-header-cell *matHeaderCellDef>  Typ użytkownika </th>
      <td mat-cell *matCellDef="let element" >
        {{ element.roles.includes('ROLE_ASF360')? 'ASF360' : element.roles.includes('ROLE_ADMIN') ? 'Admin' : 'Pracownik'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="active">
      <th mat-header-cell *matHeaderCellDef> Aktywny </th>
      <td mat-cell *matCellDef="let element">
        {{element.active ? 'Tak' : 'Nie'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="firstName">
      <th mat-header-cell *matHeaderCellDef> Imię </th>
      <td mat-cell *matCellDef="let element">
        {{element.firstName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="lastName">
      <th mat-header-cell *matHeaderCellDef> Nazwisko </th>
      <td mat-cell *matCellDef="let element">
        {{element.lastName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef> Numer telefonu </th>
      <td mat-cell *matCellDef="let element">
        {{element.phone | phone}}
      </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef> Email </th>
      <td mat-cell *matCellDef="let element">
        {{element.email}}
      </td>
    </ng-container>

    <ng-container matColumnDef="department">
      <th mat-header-cell *matHeaderCellDef> Dział </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.department" class="default-link" [routerLink]="['/uzytkownicy/dzialy/szczegoly', element.department.uuid]">{{element.department.name}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="supervisor">
      <th mat-header-cell *matHeaderCellDef> Przełożony </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.department?.supervisorId" class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.department?.supervisorId]">{{element.department?.supervisorFullName}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef>  </th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="null !== this.permissionTagId"  (click)="delete(element.uuid)" mat-icon-button color="warn"><mat-icon>delete</mat-icon></button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
